/**
 * Redraw the UI after post revision updates.
 */
export default function redrawPost() {
  m.redraw();
}
flarum.reg.add('huseyinfiliz-diff', 'forum/utils/redrawPost', redrawPost);